import { Component } from '@angular/core';

@Component({
  selector: 'app-terms-popup',
  templateUrl: './terms-popup.component.html'
})
export class TermsPopupComponent {
  constructor() {}
}
